import XInput from '../common/XInput';
import XResizableTextarea from '../common/XResizableTextarea';
import useLifecareStudioField from '../../hooks/useLifecareStudioField';
import { fieldLabelClasses, fieldMinHeight } from './lifecareStudioClasses';

// a single-line textarea starting at the input's height, so headings and names grow
// instead of clipping. Numeric fields keep the real number input (spinner, key guards).
const singleLineProps = { minHeight: fieldMinHeight, singleLine: true };

const LifecareStudioField = ({
  name,
  label,
  type = 'text',
  multiline = false,
  placeholder,
  min,
  step,
  className,
}) => {
  const fieldProps = useLifecareStudioField({ name, placeholder, className, type });

  return (
    <label className="block">
      {label && <span className={fieldLabelClasses}>{label}</span>}
      {type === 'number' ? (
        <XInput {...fieldProps} type={type} min={min} step={step} />
      ) : (
        <XResizableTextarea {...fieldProps} {...(multiline ? {} : singleLineProps)} />
      )}
    </label>
  );
};

export default LifecareStudioField;
